import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Lightbox from 'react-image-lightbox';
import 'commons-general/components/LightBox/LightBox.scss';

class LightBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentImageIndex: props.imageIndex,
        };

        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            currentImageIndex: newProps.imageIndex,
        });
    }

    openLightbox(index, event) {
        event.preventDefault();
        this.setState({
            currentImageIndex: index,
        });
    }

    gotoPrevious() {
        this.setState((prevState) => {
            const prevIndex =
                prevState.currentImageIndex > 0 ? prevState.currentImageIndex - 1 : this.props.pictures.length - 1;
            return { currentImageIndex: prevIndex };
        });
    }

    gotoNext() {
        this.props.onGoToNext();
        this.setState((prevState) => {
            const nextIndex =
                prevState.currentImageIndex < this.props.pictures.length - 1 ? prevState.currentImageIndex + 1 : 0;
            return { currentImageIndex: nextIndex };
        });
    }

    render() {
        const { pictures, toggleLightBox } = this.props;
        const { currentImageIndex } = this.state;
        const lightboxImages = pictures.map((image) => image?.src || image);
        const nextImageIndex = currentImageIndex < pictures.length - 1 ? currentImageIndex + 1 : 0;
        const prevImageIndex = currentImageIndex > 0 ? currentImageIndex - 1 : pictures.length - 1;

        const modalStyles = {
            overlay: {
                zIndex: 10000,
            },
            content: {},
        };

        return (
            <Lightbox
                mainSrc={lightboxImages[currentImageIndex]}
                nextSrc={lightboxImages[nextImageIndex]}
                prevSrc={lightboxImages[prevImageIndex]}
                onCloseRequest={toggleLightBox}
                onMovePrevRequest={this.gotoPrevious}
                onMoveNextRequest={this.gotoNext}
                enableZoom={false}
                reactModalStyle={modalStyles}
                toolbarButtons={[`${currentImageIndex + 1} / ${pictures.length}`]}
            />
        );
    }
}

LightBox.propTypes = {
    pictures: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string,
        })
    ),
    toggleLightBox: PropTypes.func.isRequired,
    imageIndex: PropTypes.number.isRequired,
    onGoToNext: PropTypes.func,
};

LightBox.defaultProps = {
    pictures: [],
    onGoToNext: noop,
};

LightBox.displayName = 'LightBox';

export default LightBox;
